export const CHANGE_ENTITY_STACK_TAB = 'CHANGE_ENTITY_STACK_TAB'
export const TOGGLE_ENTITY_STACK = 'TOGGLE_ENTITY_STACK'
export const OPEN_ENTITY_STACK = 'OPEN_ENTITY_STACK'

const SEARCH_TAB = 'search'
const FAVOURITES_TAB = 'favourites'
const GROUPS_TAB = 'groups'
const HISTORY_TAB = 'history'
const EXPORTS_TAB = 'exports'

export const TAB_TYPE = [SEARCH_TAB, FAVOURITES_TAB, GROUPS_TAB, HISTORY_TAB, EXPORTS_TAB]
